
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { Text } from 'office-ui-fabric-react';

const UsekSelectorView = ({
    onChange,
    usekId,
    usekMezItems
}) => {

    const getOptions = () => {
        return (usekMezItems || []).map(item => {
            return {
                key: item.properties.id_usek,
                text: item.properties.id_usek
            };
        });
    }

    const handleChange = (e, option) => {
        if (onChange) {
            onChange(option.key);
        }
    }

    return (
        <Stack horizontal>
            <Stack.Item grow>
                <Text>Výběr úseku meze pro zadání atributů</Text>
            </Stack.Item>
            <Stack.Item grow>
                <ComboBox
                    selectedKey={usekId}
                    options={getOptions()}
                    onChange={handleChange}
                />
            </Stack.Item>
        </Stack>
    )
}

export default UsekSelectorView;
